import { ref } from 'vue';
import { useLocaleStore } from '~/stores/useLocaleStore';
import { LANG } from "~/enums/Lang";

interface TOptionsModel {
  variables?: Record<string, string>;
  context?: string | null;
}

export interface TranslationBatchModel {
  content: string;
  context: string | null;
}

export const useLocale = () => {
  const t = (content: string, options?: TOptionsModel)=> {
    const { json, languages, currentIsoCode, newTranslations, isLocaleReady } = useLocaleStore();

    const trimmedContent = content?.trim();
    const isRussian = /[а-яА-ЯёЁ]/.test(trimmedContent);
    const returnedValue = isRussian ? 'Not translated' : trimmedContent;
    const isDefaultLocale = currentIsoCode.value === LANG.RU;

    if (isRussian && isDefaultLocale) {
      return trimmedContent;
    }

    if (!json.value) {
      return returnedValue;
    }

    const currentContent = options?.context ? `${trimmedContent} {[${options.context}]}` : trimmedContent;

    if (!json.value[currentContent] && trimmedContent) {
      if (isRussian && !isDefaultLocale) {
        const obj: TranslationBatchModel = {
          content: trimmedContent,
          context: options?.context ?? null,
        };
        newTranslations.value.push(obj);
      }
      json.value[currentContent] = returnedValue;
      return returnedValue;
    }

    if (options?.variables) {
      return json.value[currentContent].replace(/\[\[.*?\]\]/g, (val: string) => {
        const match = val.match(/\[\[\s*(.*?)\s*\]\]/);
        if (match && options.variables) {
          return options.variables[match[1]] ?? '';
        }
        return val;
      });
    }

    return json.value[currentContent] || returnedValue;
  }

  return {
    t,
  }
}